(function initBagDrawer() {
  var drawer     = document.getElementById('bag-drawer');
  var scrim      = document.getElementById('bag-scrim');
  var empty      = document.getElementById('bag-empty');
  var lines      = document.getElementById('bag-lines');
  var footer     = document.getElementById('bag-footer');
  var countEl    = document.getElementById('bag-count');
  var subtotalEl = document.getElementById('bag-subtotal');
  var headerBadge = document.querySelector('.cart-badge');

  if (!drawer) return;

  /* ── Open / close ── */
  function openBag() {
    drawer.classList.add('is-open');
    scrim.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function closeBag() {
    drawer.classList.remove('is-open');
    scrim.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-action="open-bag"]').forEach(function (btn) {
    btn.addEventListener('click', openBag);
  });
  document.querySelectorAll('[data-action="close-bag"]').forEach(function (btn) {
    btn.addEventListener('click', closeBag);
  });

  scrim.addEventListener('click', closeBag);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeBag();
  });

  /* ── Fetch cart ── */
  function fetchCart() {
    fetch('/cart.js')
      .then(function (r) {
        if (!r.ok) throw new Error('cart fetch failed');
        return r.json();
      })
      .then(function (cart) { renderCart(cart); })
      .catch(function () {});
  }

  /* ── Helpers ── */
  var cartCurrency = 'USD';

  function money(cents) {
    if (typeof cents !== 'number' || isNaN(cents)) cents = 0;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: cartCurrency
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function esc(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  /* ── Render ── */
  function renderCart(cart) {
    /* An error response ({description: ...}) has no items array — never
       render it as if it were a cart. */
    if (!cart || !Array.isArray(cart.items)) return;

    if (cart.currency) cartCurrency = cart.currency;
    var count = cart.item_count;

    if (countEl) countEl.textContent = count;
    if (headerBadge) {
      headerBadge.textContent = count;
      headerBadge.style.display = count > 0 ? '' : 'none';
    }

    if (count === 0) {
      lines.innerHTML = '';
      empty.style.display = '';
      footer.style.display = 'none';
    } else {
      empty.style.display = 'none';
      footer.style.display = '';
      if (subtotalEl) {
        if (cart.total_discount > 0 && cart.original_total_price > cart.total_price) {
          subtotalEl.innerHTML =
            '<s class="bag-subtotal__compare">' + money(cart.original_total_price) + '</s> ' +
            '<span class="bag-subtotal__now">' + money(cart.total_price) + '</span>';
        } else {
          subtotalEl.textContent = money(cart.total_price);
        }
      }

      renderAppliedDiscount(cart);

      lines.innerHTML = cart.items.map(function (item) {
        var key = esc(item.key);
        var img = item.image
          ? '<img src="' + esc(item.image) + '" alt="" loading="lazy">'
          : '';
        var parts = [];
        if (item.variant_title && item.variant_title !== 'Default Title') parts.push(item.variant_title);
        if (item.product_type) parts.push(item.product_type);
        var sub = parts.join(' · ');
        return '<li class="bag-line" data-key="' + key + '">' +
          '<div class="bag-line__image">' + img + '</div>' +
          '<div class="bag-line__info">' +
            '<div class="bag-line__name">' + esc(item.product_title) + '</div>' +
            (sub ? '<div class="bag-line__sub">' + esc(sub) + '</div>' : '') +
            '<div class="bag-line__controls">' +
              '<div class="bag-qty">' +
                '<button class="bag-qty__btn" data-key="' + key + '" data-qty="' + (item.quantity - 1) + '" type="button" aria-label="Decrease quantity">−</button>' +
                '<span class="bag-qty__val">' + item.quantity + '</span>' +
                '<button class="bag-qty__btn" data-key="' + key + '" data-qty="' + (item.quantity + 1) + '" type="button" aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<button class="bag-line__remove" data-key="' + key + '" type="button">Remove</button>' +
            '</div>' +
          '</div>' +
          '<div class="bag-line__price">' + money(item.final_line_price) + '</div>' +
          '</li>';
      }).join('');

      /* Quantity buttons */
      lines.querySelectorAll('.bag-qty__btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var qty = parseInt(this.dataset.qty, 10);
          if (isNaN(qty) || qty < 0) return;
          changeLine(this.dataset.key, qty);
        });
      });

      /* Remove buttons */
      lines.querySelectorAll('.bag-line__remove').forEach(function (btn) {
        btn.addEventListener('click', function () {
          changeLine(this.dataset.key, 0);
        });
      });
    }
  }

  /* ── Change line quantity (Dawn-style: line item key + urlencoded body) ── */
  var changing = false;

  function changeLine(key, quantity) {
    if (changing || !key) return;
    changing = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: 'id=' + encodeURIComponent(key) + '&quantity=' + quantity
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) {
            /* Shopify rejected the change (e.g. sold out) — show why */
            showCartError(data && (data.description || data.message));
            throw new Error('change rejected');
          }
          return data;
        });
      })
      .then(function (cart) {
        changing = false;
        renderCart(cart);
      })
      .catch(function () {
        changing = false;
        /* Re-sync with the real cart state instead of trusting anything local */
        fetchCart();
      });
  }

  /* ── Inline error message ── */
  var errorTimer = null;

  function showCartError(msg) {
    if (!msg) return;
    var el = document.getElementById('bag-error');
    if (!el) {
      el = document.createElement('p');
      el.id = 'bag-error';
      el.className = 'bag-error';
      el.setAttribute('aria-live', 'polite');
      var body = document.getElementById('bag-body');
      if (body) body.insertBefore(el, body.firstChild);
    }
    el.textContent = msg;
    el.style.display = '';
    clearTimeout(errorTimer);
    errorTimer = setTimeout(function () { el.style.display = 'none'; }, 4000);
  }

  /* ── Promo code ──
     Native Shopify cart discounts: POST /cart/update.js with discount=CODE.
     The cart JSON returns discount_codes[] + discounted totals, and the
     code carries through to checkout automatically. */
  var discountInput = document.getElementById('bag-discount-input');
  var discountApply = document.getElementById('bag-discount-apply');
  var discountMsg   = document.getElementById('bag-discount-msg');

  function setDiscountMsg(text, tone) {
    if (!discountMsg) return;
    discountMsg.textContent = text;
    discountMsg.className = 'bag-discount__msg' + (tone ? ' bag-discount__msg--' + tone : '');
  }

  /* Persistent applied-code display: whenever the cart carries an applicable
     discount code, show it with the saving and a Remove control — even after
     a page reload or reopening the drawer. */
  function renderAppliedDiscount(cart) {
    var applied = (cart.discount_codes || []).filter(function (d) { return d.applicable; });
    if (!discountMsg) return;
    if (applied.length) {
      var saved = cart.total_discount ? ' — you save ' + money(cart.total_discount) : '';
      discountMsg.className = 'bag-discount__msg bag-discount__msg--ok';
      discountMsg.innerHTML = esc(applied[0].code.toUpperCase()) + ' applied' + saved + '. ' +
        '<button type="button" class="bag-discount__remove" data-action="remove-discount">Remove</button>';
    } else if (discountMsg.querySelector('[data-action="remove-discount"]')) {
      /* only clear messages we own; leave error feedback alone */
      setDiscountMsg('', '');
    }
  }

  document.addEventListener('click', function (e) {
    if (e.target && e.target.dataset && e.target.dataset.action === 'remove-discount') {
      if (discountInput) discountInput.value = '';
      updateDiscount('');
    }
  });

  function updateDiscount(code) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: 'discount=' + encodeURIComponent(code)
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) return;
        var applied = (cart.discount_codes || []).filter(function (d) { return d.applicable; });
        renderCart(cart); /* also renders the applied-code message */
        if (code !== '' && !applied.length) {
          setDiscountMsg('Code not valid for this bag.', 'err');
        } else if (code === '') {
          setDiscountMsg('', '');
        }
      })
      .catch(function () {
        setDiscountMsg('Could not apply code — try again.', 'err');
      });
  }

  function applyDiscount() {
    var code = discountInput ? discountInput.value.trim() : '';
    updateDiscount(code); /* empty code clears any applied discount */
  }

  if (discountApply) discountApply.addEventListener('click', applyDiscount);
  if (discountInput) {
    discountInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') applyDiscount();
    });
  }

  /* ── Open automatically after ATC ── */
  document.addEventListener('mekeni:bag:added', openBag);
})();
